/**
 * User-friendly formatting for PostGrid enum values
 * Converts technical enum values into readable labels
 */

export const formatChequeType = (chequeType: string | undefined): string => {
  if (!chequeType) return 'Standard Check';
  switch (chequeType) {
    case 'business':
      return 'Business Check';
    case 'personal':
      return 'Personal Check';
    case 'payroll':
      return 'Payroll Check';
    case 'government':
      return 'Government Check';
    default:
      return chequeType
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (l) => l.toUpperCase());
  }
};

export const formatChequeSize = (chequeSize: string | undefined): string => {
  if (!chequeSize) return 'Standard Size';
  switch (chequeSize) {
    case '8.5x3.5':
      return '8.5" × 3.5" (Standard)';
    case '8.5x11':
      return '8.5" × 11" (Full Page)';
    case '3.33x8.66':
      return '3.33" × 8.66" (Wallet Size)';
    default:
      return chequeSize.replace(/x/g, ' × ');
  }
};

export const formatLetterSize = (letterSize: string | undefined): string => {
  if (!letterSize) return 'US Letter';
  switch (letterSize) {
    case 'us_letter':
      return 'US Letter (8.5" × 11")';
    case 'us_legal':
      return 'US Legal (8.5" × 14")';
    case 'a4':
      return 'A4 (210 × 297 mm)';
    case 'a5':
      return 'A5 (148 × 210 mm)';
    default:
      return letterSize
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (l) => l.toUpperCase());
  }
};

export const formatMailingClass = (
  mailingClass: string | undefined,
): string => {
  if (!mailingClass) return 'Standard Mail';
  switch (mailingClass) {
    case 'usps_first_class':
      return 'USPS First-Class Mail';
    case 'usps_standard':
      return 'USPS Ground Advantage';
    case 'usps_priority':
      return 'USPS Priority Mail';
    case 'usps_priority_express':
      return 'USPS Priority Mail Express';
    case 'ups_ground':
      return 'UPS Ground';
    case 'ups_next_day_air':
      return 'UPS Next Day Air';
    case 'fedex_ground':
      return 'FedEx Ground';
    case 'fedex_2_day':
      return 'FedEx 2Day';
    case 'fedex_overnight':
      return 'FedEx Standard Overnight';
    default:
      return mailingClass
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (l) => l.toUpperCase());
  }
};

export const formatAddressPlacement = (
  addressPlacement: string | undefined,
): string => {
  if (!addressPlacement) return 'Top of First Page';
  switch (addressPlacement) {
    case 'top_first_page':
      return 'Top of First Page';
    case 'insert_blank_page':
      return 'Separate Address Page';
    case 'top_left':
      return 'Top Left';
    case 'top_right':
      return 'Top Right';
    case 'bottom_left':
      return 'Bottom Left';
    case 'bottom_right':
      return 'Bottom Right';
    default:
      return addressPlacement
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (l) => l.toUpperCase());
  }
};

/**
 * Generic formatter for any enum value - converts snake_case to Title Case
 */
export const formatEnumValue = (value: string | undefined): string => {
  if (!value) return '';
  return value.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());
};
